.root {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: var(--spacingMd);
  width: fit-content;
}

.labelAndIcons {
  display: flex;
  gap: var(--spacingSm);
  align-items: center;
  justify-content: end;
}
